const toUTF8 = function (str) {
  const encoded = encodeURIComponent(str);
  const utf8 = unescape(encoded);
  const result = new Uint8Array(utf8.length);
  for (let i = 0; i < utf8.length; ++i) {
    result[i] = utf8.charCodeAt(i);
  }
  return result.buffer;
};

export default toUTF8;
